import { Datepicker } from "@mobiscroll/react";
import { useEffect, useState } from "react";
import Form from "react-bootstrap/Form";
import AsyncTypeahead, { DataListType } from "../../../../components/AsyncTypeahead";
import { formatDate } from "../../../../helper/dateFormatter";
import { calculateAge } from "../../commonUtils";
import { createPatientApi } from "../../../../api-helpers/PatientApiHelper";
import Toaster, { ToastConfig } from "../../../../components/Toaster";
import { ErrorTypes } from "../../../../interfaces/errors";
import { UpdatePatientPersonalDetails } from "patients-experience-client";
import { createCommonUtilsApi, createLocationApi } from "../../../../api-helpers/CommonUtilsApiHelper";
import { IdValuePairDTO } from "common-util-experience-client";
import Spinner from "../../../../components/Spinner";
import '../../../../assets/scss/custom/_custom.scss';
import { stat } from "fs";
import { capitalizeInitial } from "../../../../helper/TextUtils";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../../store";
import { setPatientProfileReloadKey } from "../../../../store/slices/patientProfileReload";

export const EditPersonalDetails = (props: any) => {
    const patientInfo = props.patientInfo;
    const locationApi = createLocationApi()
    const [loading, setloading] = useState(false);
    const [showToast, setShowToast] = useState(false);
    const [validated, setValidated] = useState(false);
    const patientApi = createPatientApi();
    const [selectedPhysicalCity, setSelectedPhysicalCity] = useState<string>("");
    const [selectedMailingCity, setSelectedMailingCity] = useState<string>("");
    const [selectedPhysicalState, setSelectedPhysicalState] = useState<string>("");
    const [selectedMailingState, setSelectedMailingState] = useState<string>("");
    const [invalidPhysicalZipCode, setInvalidPhysicalZipCode] = useState<boolean>(false);
    const [invalidMailingZipCode, setInvalidMailingZipCode] = useState<boolean>(false);
    const [mailingCityList, setMailingCityList] = useState<IdValuePairDTO[]>([]);
    const [physicalCityList, setPhysicalCityList] = useState<IdValuePairDTO[]>([]);
    const [countries, setCountries] = useState<Array<IdValuePairDTO>>([]);
    const [toastConfig, setToastConfig] = useState<ToastConfig>({
        type: "success" as ErrorTypes,
        title: "",
        icon: "",
    });
    const patientId = patientInfo?.patientId
    const [form, setForm] = useState<UpdatePatientPersonalDetails>({} as UpdatePatientPersonalDetails);

    const patientProfileReloadKey = useSelector((state: RootState) => state.patientProfileReloadKey.patientProfileReloadKey);
    const dispatch = useDispatch();


    useEffect(() => {
        const getData = async () => {
            if (patientInfo) {
                if (patientInfo?.physicalAddressZipcode?.length === 5) {
                    await fetchZipcodeDetails(patientInfo.physicalAddressZipcode, 'physicalAddressZipcode')
                }
                if (patientInfo?.mailingAddressZipcode?.length === 5) {
                    await fetchZipcodeDetails(patientInfo.mailingAddressZipcode, 'mailingAddressZipcode')
                }
                await setForm({
                    ...form,
                    spireHealthPortalId:patientInfo?.spireHealthPortalId || "",
                    preferredName:patientInfo?.preferredName || "",
                    physicalAddress: patientInfo?.physicalAddress || "",
                    physicalAddressCityId: patientInfo?.physicalAddressCity?.id || "",
                    physicalAddressStateId: patientInfo?.physicalAddressState?.id || "",
                    physicalAddressZipcode: patientInfo?.physicalAddressZipcode || "",
                    mailingAddress: patientInfo?.mailingAddress || "",
                    mailingAddressCityId: patientInfo?.mailingAddressCity?.id || "",
                    mailingAddressStateId: patientInfo?.mailingAddressState?.id || "",
                    mailingAddressZipcode: patientInfo?.mailingAddressZipcode || "",
                    countryId: patientInfo?.country?.id || "",
                    timeZone: patientInfo?.timeZone || "",
                });
            }
        }
        loadCountries();
        getData();
    }, [patientInfo]);

    const submitHandler = async (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();
        setValidated(true);

        const physicalAddressZipcodeInputField = document.querySelector('[name="physicalAddressZipcode"]') as HTMLInputElement;
        const mailingAddressZipcodeInputField = document.querySelector('[name="mailingAddressZipcode"]') as HTMLInputElement;

        let isValid = true;
        if(physicalAddressZipcodeInputField.value.length !== 5){
            physicalAddressZipcodeInputField.setCustomValidity("Invalid Zipcode");
            setInvalidPhysicalZipCode(true);
            isValid = false;
        }

        if(mailingAddressZipcodeInputField.value.length !== 5){
            setInvalidMailingZipCode(true);
            mailingAddressZipcodeInputField.setCustomValidity("Invalid Zipcode");
            isValid = false;
        }

        if(!isValid){
            return;
        }

        if (physicalAddressZipcodeInputField.value.length && (form.physicalAddressStateId === undefined || form.physicalAddressStateId === '') && (form.physicalAddressCityId === undefined || form.physicalAddressCityId === '')) {
            physicalAddressZipcodeInputField.setCustomValidity("Invalid Zipcode");
        } else {
            physicalAddressZipcodeInputField.setCustomValidity("");
        }

        if (mailingAddressZipcodeInputField.value.length && (form.mailingAddressStateId === undefined || form.mailingAddressStateId === '') && (form.mailingAddressCityId === undefined || form.mailingAddressCityId === '')) {
            mailingAddressZipcodeInputField.setCustomValidity("Invalid Zipcode");
        } else {
            mailingAddressZipcodeInputField.setCustomValidity("");
        }

        if (invalidPhysicalZipCode && form.physicalAddressZipcode !== '') {
            physicalAddressZipcodeInputField.setCustomValidity("Invalid Zipcode");
        } else {
            physicalAddressZipcodeInputField.setCustomValidity("");
        }
        if (invalidMailingZipCode && form.mailingAddressZipcode !== '') {
            mailingAddressZipcodeInputField.setCustomValidity("Invalid Zipcode");
        } else {
            mailingAddressZipcodeInputField.setCustomValidity("");
        }

        const addForm = event.currentTarget;
        if (!addForm.checkValidity()) {
            event.preventDefault();
            event.stopPropagation();
            return;
        }
        
        setloading(true);
        try {
            await patientApi.patientsControllerUpdatePersonalDetails(form, patientInfo.patientId);
            showSuccessMessage();
            setTimeout(() => {
                handleDiscard();
                dispatch(setPatientProfileReloadKey(patientProfileReloadKey + 1))
            }, 1500);
            setloading(false);
            props.loadPersonalDetails();
        } catch (error) {
            console.error(error);
            setloading(false);
            showErrorMessage();
        }
    };

    const showSuccessMessage = () => {
        setShowToast(false);
        const toasterConfig: ToastConfig = {
            type: "success",
            title: "Details Updated Successfully",
            icon: "check_circle_outline",
        };
        setToastConfig(toasterConfig);
        setShowToast(true);
    }

    const showErrorMessage = () => {
        setShowToast(false);
        const toasterConfig: ToastConfig = {
            type: "danger",
            title: "Error while updating Details!",
            icon: "error_outline",
        };
        setToastConfig(toasterConfig);
        setShowToast(true);
    }

    const loadCountries = async () => {
        setloading(true);
        try {
            const response = await locationApi.locationControllerFindAllCountries();
            setCountries(response.data);
        } catch (error: any) {
            console.log(error);
        }
        setloading(false);
    }

  

    const handleInputChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>) => {
        const { name, value } = e.target;

        if (name === "mailingAddressZipcode" || name === "physicalAddressZipcode") {
            if (value.length === 5) {
                fetchZipcodeDetails(value, name);
            } else {
                if (name === "mailingAddressZipcode") {
                    const mailingAddressZipcodeInputField = document.querySelector('[name="mailingAddressZipcode"]') as HTMLInputElement;
                    mailingAddressZipcodeInputField.setCustomValidity("");
                    setSelectedMailingCity('');
                    setSelectedMailingState('');
                    setInvalidMailingZipCode(false);
                    setForm((prevForm) => ({
                        ...prevForm,
                        mailingAddressStateId: '',
                        mailingAddressCityId: '',
                        timeZone: ''
                    }));
                }

                if (name === "physicalAddressZipcode") {
                    const physicalAddressZipcodeInputField = document.querySelector('[name="physicalAddressZipcode"]') as HTMLInputElement;
                    physicalAddressZipcodeInputField.setCustomValidity("");
                    setSelectedPhysicalCity('');
                    setSelectedPhysicalState('');
                    setInvalidPhysicalZipCode(false);
                    setForm((prevForm) => ({
                        ...prevForm,
                        physicalAddressStateId: '',
                        physicalAddressCityId: ''
                    }));
                }
            }
        }

        setForm({
            ...form,
            [name]: value
        });
    };

    const fetchZipcodeDetails = async (zipcode: string, fieldName: string) => {
        try {
            setloading(true);
            const response = await locationApi.locationControllerGetZipcodeDetails(
                zipcode
            );
            // Assuming the API returns city, state, and other details
            const { state, cities, timezone } = response.data;
            if (cities.length === 1) {
                if (fieldName === 'mailingAddressZipcode') {
                    setMailingCityList([]);
                    setInvalidMailingZipCode(false);
                    setSelectedMailingCity(cities[0].value);
                    setSelectedMailingState(state.value);
                    setForm((prevForm) => ({
                        ...prevForm,
                        mailingAddressStateId: state.id,
                        mailingAddressCityId: cities[0].id
                    }));
                } else if (fieldName === 'physicalAddressZipcode') {
                    setPhysicalCityList([]);
                    setInvalidPhysicalZipCode(false);
                    setSelectedPhysicalCity(cities[0].value);
                    setSelectedPhysicalState(state.value);
                    setForm((prevForm) => ({
                        ...prevForm,
                        physicalAddressStateId: state.id,
                        physicalAddressCityId: cities[0].id,
                        timeZone: timezone
                    }));
                }

            } else if (cities.length > 1) {
                if (fieldName === 'mailingAddressZipcode') {
                    setInvalidMailingZipCode(false);
                    setMailingCityList(cities);
                    setSelectedMailingState(state.value);
                    setForm((prevForm) => ({
                        ...prevForm,
                        mailingAddressCityId: '',
                        mailingAddressStateId: state.id,
                    }));
                } else if (fieldName === 'physicalAddressZipcode') {
                    setInvalidPhysicalZipCode(false);
                    setPhysicalCityList(cities);
                    setSelectedPhysicalState(state.value);
                    setForm((prevForm) => ({
                        ...prevForm,
                        physicalAddressCityId: '',
                        physicalAddressStateId: state.id,
                        timeZone: timezone
                    }));
                }
                setForm((prevForm) => ({
                    ...prevForm,
                    stateId: state.id,
                }));
            } else {
                // Handle case where no cities are returned
                console.error("No cities found for this zipcode");
            }
        } catch (error) {
            if (fieldName === 'mailingAddressZipcode') {
                setInvalidMailingZipCode(true);
                setMailingCityList([]);
                setForm((prevForm) => ({
                    ...prevForm,
                    mailingAddressStateId: '',
                    mailingAddressCityId: '',
                }));
                } else if (fieldName === 'physicalAddressZipcode') {
                setPhysicalCityList([]);
                setInvalidPhysicalZipCode(true);
                setForm((prevForm) => ({
                    ...prevForm,
                    physicalAddressStateId: '',
                    physicalAddressCityId: '',
                }));
            }
            console.error(error);
        } finally {
            setloading(false);
        }
    };

    const handleDiscard = () => {
        props.setOffCanvasShow(false);
    };
    return (
        <>
            {loading && <Spinner />}
            <div className="row">
                <Toaster
                    show={showToast}
                    onClose={() => setShowToast(false)}
                    type={toastConfig.type}
                    title={toastConfig.title}
                    message={toastConfig.message}
                    icon={toastConfig.icon}
                />
            </div>
            <Form
                className="d-flex flex-column h-100"
                noValidate
                validated={validated}
                onSubmit={submitHandler}
            >
                <div className="flex-fill">
                    <div className="row g-2 mb-2">
                        <div className="col-12 mb-2">
                            <label className="form-label fs-12 fw-semibold mb-0">Wellinks ID</label>
                            <input type="text" disabled className="form-control" value={patientInfo?.wellinksId} />
                        </div>
                        <div className="col-6 mb-2">
                            <label className="form-label fs-12 fw-semibold mb-0">Spire HP ID</label>
                            <input type="text" className="form-control" name="spireHealthPortalId" placeholder="Spire HP ID" onChange={handleInputChange} value={form.spireHealthPortalId} />
                        </div>
                        <div className="col-6 mb-2">
                            <label className="form-label fs-12 fw-semibold mb-0">First Name</label>
                            <input type="text" disabled className="form-control" value={capitalizeInitial(patientInfo?.firstName)} />
                        </div>
                        <div className="col-6 mb-2">
                            <label className="form-label fs-12 fw-semibold mb-0">Last Name</label>
                            <input type="text" disabled className="form-control" value={capitalizeInitial(patientInfo?.lastName)} />
                        </div>
                        <div className="col-6 mb-2">
                            <label className="form-label fs-12 fw-semibold mb-0">Preferred Name</label>
                            <input type="text" className="form-control" name="preferredName" placeholder="Preferred Name" onChange={handleInputChange} value={form.preferredName} />
                        </div>
                        <div className="col-6 mb-2">
                            <label className="form-label fs-12 fw-semibold mb-0">Gender</label>
                            <input type="text" disabled className="form-control" value={patientInfo?.genderInfo?.type} />
                        </div>
                        <div className="col-6 mb-2">
                            <label className="form-label fs-12 fw-semibold mb-0">Race</label>
                            <input type="text" disabled className="form-control" value={patientInfo?.raceInfo?.type} />
                        </div>
                        <div className="col-6 mb-2">
                            <label className="form-label fs-12 fw-semibold mb-0">Ethnicity</label>
                            <input type="text" disabled className="form-control" value={patientInfo?.ethnicityInfo?.type} />
                        </div>
                        <div className="col-6 mb-2">
                            <label className="form-label fs-12 fw-semibold mb-0">DOB</label>
                            <input type="text" disabled className="form-control" value={formatDate(patientInfo?.dob)} />
                        </div>
                        <div className="col-6 mb-2">
                            <label className="form-label fs-12 fw-semibold mb-0">Age</label>
                            <input type="text" disabled className="form-control" value={calculateAge(patientInfo?.dob.toLocaleString()) + ' Years'} />
                        </div>
                        <div className="col-12">
                            <label className="form-label fs-12 fw-semibold mb-0">Physical Address</label>
                        </div>
                        <div className="col-6 mb-0">
                            <input type="text" required className="form-control lh-1" placeholder="Address" onChange={handleInputChange} name="physicalAddress" value={form.physicalAddress} />
                        </div>
                        <div className="col-6 mb-2">
                            <input
                                type="text"
                                className="form-control lh-1"
                                id="physicalAddressStateId"
                                name="physicalAddressStateId"
                                placeholder="State"
                                value={selectedPhysicalState}
                                disabled={true}
                                required
                            />
                        </div>

                        <div className="col-6">
                            {
                                physicalCityList.length === 0 ? <input
                                    type="text"
                                    className="form-control lh-1"
                                    placeholder="City"
                                    value={selectedPhysicalCity}
                                    disabled
                                    required
                                /> : <select className="form-select" name="physicalAddressCityId" required value={form.physicalAddressCityId} onChange={handleInputChange}>
                                    <option value="">Select</option>
                                    {physicalCityList.map((city) => <option value={city.id}>{city.value}</option>)}
                                </select>
                            }                            
                        </div>
                        <div className="col-6 mb-2">
                            <input
                                type="text"
                                className={`form-control lh-1 ${invalidPhysicalZipCode && form.physicalAddressZipcode !== '' ? 'border-red' : ''}`}
                                required
                                placeholder="Zipcode"
                                onChange={handleInputChange}
                                maxLength={5}
                                name="physicalAddressZipcode"
                                value={form.physicalAddressZipcode}
                            />
                            { invalidPhysicalZipCode && form.physicalAddressZipcode !== '' ? <small style={{color: 'red'}}>Invalid Zipcode</small> : '' }
                        </div>
                        <div className="col-12">
                            <label className="form-label fs-12 fw-semibold mb-0">Mailing Address</label>
                        </div>
                        <div className="col-6 mb-0">
                            <input type="text" className="form-control lh-1" required placeholder="Address" onChange={handleInputChange} name="mailingAddress" value={form.mailingAddress} />
                        </div>
                        <div className="col-6 mb-2">

                            <input
                                type="text"
                                className="form-control lh-1"
                                id="mailingAddressStateId"
                                name="mailingAddressStateId"
                                placeholder="State"
                                value={selectedMailingState}
                                disabled={true}
                                required
                            />
                        </div>
                        <div className="col-6">
                            {
                                mailingCityList.length === 0 ? <input
                                    type="text"
                                    className="form-control lh-1"
                                    placeholder="City"
                                    value={selectedMailingCity}
                                    disabled
                                    required
                                /> : <select className="form-select" name="mailingAddressCityId" required value={form.mailingAddressCityId} onChange={handleInputChange}>
                                    <option value="">Select</option>
                                    {mailingCityList.map((city) => <option value={city.id}>{city.value}</option>)}
                                </select>
                            }
                        </div>
                        <div className="col-6 mb-2">
                            <input
                                type="text"
                                className={`form-control lh-1 ${invalidMailingZipCode && form.mailingAddressZipcode !== '' ? 'border-red' : ''}`}
                                placeholder="Zipcode"
                                required
                                onChange={handleInputChange}
                                maxLength={5}
                                name="mailingAddressZipcode"
                                value={form.mailingAddressZipcode}
                            />
                            { invalidMailingZipCode && form.mailingAddressZipcode !== '' ? <small style={{color: 'red'}}>Invalid Zipcode</small> : '' }
                        </div>
                        <div className="col-12 mb-2">
                            <label className="form-label fs-12 fw-semibold mb-0">Country</label>
                            <select className="form-select" name="countryId" required value={form.countryId} onChange={handleInputChange}>
                                <option value="">Select</option>
                                {countries.length && countries.map((country) => <option value={country.id}>{country.value}</option>)}
                            </select>
                        </div>
                        <div className="col-12 mb-2">
                            <label className="form-label fs-12 fw-semibold mb-0">Time Zone</label>
                            <input type="text" className="form-control" required placeholder="Time Zone" value={form.timeZone} name="timeZone" disabled={true} />
                        </div>
                    </div>
                </div>
                <div className="offcanvas-footer text-end w-100 border-top d-flex justify-content-between border-top">
                    <div>
                        <button
                            className="btn btn-outline-secondary rounded-pill px-5 fs-13"
                            type="reset"
                            onClick={handleDiscard}
                        >
                            Discard
                        </button>
                    </div>
                    <div>
                        <button
                            className="btn btn-secondary rounded-pill ps-4 pe-5 fs-13"
                            type="submit"
                        >
                            Update
                        </button>
                    </div>
                </div>
            </Form>
        </>
    );
};